/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AcceptedBidDataDto } from '../../models/accepted-bid-data-dto';
import { AcceptedBidDto } from '../../models/accepted-bid-dto';

export interface CreateAcceptedBid$Params {
  'X-API-Version'?: string;
      body: AcceptedBidDataDto
}

export function createAcceptedBid(http: HttpClient, rootUrl: string, params: CreateAcceptedBid$Params, context?: HttpContext): Observable<StrictHttpResponse<AcceptedBidDto>> {
  const rb = new RequestBuilder(rootUrl, createAcceptedBid.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AcceptedBidDto>;
    })
  );
}

createAcceptedBid.PATH = '/api/accepted-bids';
